import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';
import { getUnionModule } from '@/views/custom-layout/api';
import { guid } from '@/utils';
export default {
  name: 'saas_module_plate_nav_config',
  components: {
    draggable: draggable
  },
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      moduleList: [],
      rules: {
        value: [{
          required: true,
          validator: function validator(_, value, callback) {
            if (!value || value.length < 1) callback('至少添加一个分类');
            callback();
          },
          trigger: 'change'
        }],
        activity_num: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (!/^[0-9]*$/.test(value)) {
              callback('仅支持正整数');
            } else if (value > 99 || value < 1) {
              callback('仅支持1-99正整数');
            } else {
              callback();
            }
          },
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    // 选择板块后 同步模块id及类型
    changeModule: function changeModule(val, item) {
      var data = this.moduleList.find(function (i) {
        return i.id === val;
      });
      var _ref = data || {},
        _ref$module_id = _ref.module_id,
        module_id = _ref$module_id === void 0 ? '' : _ref$module_id,
        _ref$module_type = _ref.module_type,
        module_type = _ref$module_type === void 0 ? '' : _ref$module_type,
        _ref$open_module_type = _ref.open_module_type,
        open_module_type = _ref$open_module_type === void 0 ? '' : _ref$open_module_type;
      item.module_id = module_id;
      item.module_type = module_type;
      item.open_module_type = open_module_type;
    },
    getUnionModuleList: function getUnionModuleList() {
      var _this = this;
      // 获取SaaS板块下拉数据
      var _this$info = this.info,
        customer_id = _this$info.customer_id,
        module = _this$info.module;
      getUnionModule({
        customer_id: customer_id
      }, module).then(function (res) {
        _this.moduleList = res.data;
      });
    },
    addCategory: function addCategory() {
      this.value.config.value.push({
        name: "\u5206\u7C7B".concat(this.value.config.value.length + 1),
        module_id: '',
        module_type: '',
        open_module_type: '',
        module_plate_id: '',
        uid: guid()
      });
    },
    handleDel: function handleDel(index) {
      var _this2 = this;
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this2.value.config.value.splice(index, 1);
      }).catch(function () {});
    }
  },
  created: function created() {
    this.getUnionModuleList();
    // 新拖入组件 config 为 undefined，需兜底避免读取 .value 抛错
    var config = this.value.config || {};
    var rawValue = config.value || this.value.config_default_value && this.value.config_default_value.value || Array.from({
      length: 3
    }, function (_, index) {
      return {
        name: "\u5206\u7C7B".concat(index + 1),
        module_id: '',
        module_type: '',
        open_module_type: '',
        module_plate_id: '',
        uid: guid()
      };
    });
    var value = rawValue.map(function (item) {
      return _objectSpread(_objectSpread({
        name: '',
        module_id: '',
        module_type: '',
        open_module_type: '',
        module_plate_id: ''
      }, item), {}, {
        uid: item.uid || guid()
      });
    });
    this.$set(this.value, 'config', _objectSpread(_objectSpread(_objectSpread({
      module_name_font_size: 28,
      //分类字号
      module_name_font_color: '#c20c0c',
      //分类颜色
      activity_name_font_size: 28,
      //活动名称字体大小
      activity_name_font_color: '#333333',
      //活动名称字体颜色
      activity_num: '5',
      //展示活动个数
      margin_top: 15,
      //和上个组件间距
      z_index: 2
    }, this.value.config_default_value), config), {}, {
      value: value
    }));
  }
};